import { defaultHttpClient } from '../../httpClient';

export type OptionGroup = {
  depth: number;
  name: string;
  single_option_sno: number | null;
};

export type GoodsOptionsBriefResponse = {
  today_delivery_order_deadline_time: string;
  minimum_order_amount: number;
  option_groups: OptionGroup[];
  minimum_order_required_category: { name: string } | null;
  text_option: { title: string; placeholder: string } | null;
  goods_delivery_type: 'today' | 'shak' | 'standard';
  option_names: string[];
};

export const getGoodsOptionsBrief = (goodsSno: number) => {
  return defaultHttpClient
    .request<GoodsOptionsBriefResponse>({
      method: 'GET',
      url: `/api/v2/goods/${goodsSno}/options/brief/`,
    })
    .then(result => result.data);
};
